import React from 'react'
import { TitleImage, BackActionHeader } from '../../../shared'
import { sittingOnMoney } from '../../../../images'
import { ActivityIndicator, Text, Button } from '../../../generic'
import DocumentListItem from '../../DocumentListItem'
import { navigate } from 'gatsby-link'
import { useQuery } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'
import { MokuNotePanel } from '../../../shared'

const GET_CREDIT_WORTHINESS_ASSESSMENTS = gql`{
  myClient {
    id
    creditWorthinessAssessments {
      id
      state
      reportNumber
      applicationDate
      report {
        id
        fileId
      }
    }
  }
}`

const stateLabels = {
  'APPLICATION': 'Application',
  'PROCESSING': 'Processing',
  'INFO_REQUIRED': 'Info Required',
  'AWAITING_PAYMENT': 'Awaiting Payment',
  'COMPLETED': 'Completed',
  'CANCELLED': 'Cancelled'
}

function CreditWorthinessAssessments({ location }) {
  const { loading, error, data } = useQuery(GET_CREDIT_WORTHINESS_ASSESSMENTS)

  // Check if user came from dashboard or home
  const fromDashboard = location?.state?.fromDashboard || (typeof window !== 'undefined' && document.referrer.includes('/dashboard'))
  const fromHome = location?.state?.fromHome || (typeof window !== 'undefined' && document.referrer.includes('/welcome'))

  const backTitle = fromHome ? "Home" : (fromDashboard ? "My Debt" : "Document Vault")
  const backPath = fromHome ? "/" : (fromDashboard ? "/debt" : "/documents")

  if (loading || error) {
    return <>
      <BackActionHeader title={backTitle} onClick={() => navigate(backPath)} />
      <TitleImage title="Credit Worthiness Assessments" description="View all your credit worthiness assessments and reports." image={sittingOnMoney} />
      {loading && <ActivityIndicator />}
      {!loading && error && <Text>Error loading assessments</Text>}
    </>
  }

  const { creditWorthinessAssessments } = data.myClient

  // Sort by most recent first
  const sortedAssessments = [...creditWorthinessAssessments].sort((a, b) => b.applicationDate - a.applicationDate)

  // Check if most recent assessment is older than a month
  const mostRecentAssessment = sortedAssessments[0]
  const isOlderThanMonth = mostRecentAssessment && moment().diff(moment(mostRecentAssessment.applicationDate), 'months') >= 1

  return <>
    <BackActionHeader title={backTitle} onClick={() => navigate(backPath)} />
    <TitleImage title="Credit Worthiness Assessments" description="View all your credit worthiness assessments and reports." image={sittingOnMoney} />

    {isOlderThanMonth && (
      <>
        <MokuNotePanel
          title="Get an Updated Assessment"
          description={`Things change over time. Your last assessment was prepared on ${moment(mostRecentAssessment.applicationDate).format('DD MMMM YYYY')}. Consider getting an updated assessment to see your current credit worthiness.`}
          footer={
            <center style={{ width: '100%', paddingTop: '8px', paddingBottom: '8px' }}>
              <Button inverted onClick={() => navigate('/credit-worthiness')}>
                Get Updated Assessment
              </Button>
            </center>
          }
        />
        <p />
      </>
    )}

    {sortedAssessments.length === 0 ? (
      <>
        <Text>You have no credit worthiness assessments yet.</Text>
        <p />
        <center>
          <Button onClick={() => navigate('/credit-worthiness')}>
            Get Your First Assessment
          </Button>
        </center>
      </>
    ) : (
      <>
        {sortedAssessments.map(({ id, reportNumber, applicationDate, state }) => (
          <DocumentListItem
            key={id}
            title={`${reportNumber} - ${moment(applicationDate).format('DD MMM YYYY')} (${stateLabels[state] || state})`}
            onClick={() => navigate(`/documents/credit-worthiness/${id}`, {
              state: { fromHome, fromDashboard }
            })}
          />
        ))}
      </>
    )}
    <div style={{ height: "100px" }} />
  </>
}

export default CreditWorthinessAssessments
